export default __webpack_public_path__ + "static/anschlussplan-poe8000-switch-d67831b15a41fc23915da88a87e4b731.webp";